<template>
  <div
    class="Requirements"
    @click="$emit('close')"
  >
    <div
      class="container"
      @click.stop
    >
      <ul>
        <li>{{ $t('REQUIREMENTS.TITLE') }}</li>
        <br>
        <li>{{ $t('REQUIREMENTS.TEXTA') }}</li>
        <li>{{ $t('REQUIREMENTS.TEXTB') }}</li>
        <li>{{ $t('REQUIREMENTS.TEXTC') }}</li>
        <li>{{ $t('REQUIREMENTS.TEXTD') }}</li>
        <li>
          {{ $t('REQUIREMENTS.TEXTE') }}
        </li>
        <li>
          {{ $t('REQUIREMENTS.TEXTE') }}
        </li>
      </ul>

      <!-- <BaseButton
        @click="$emit('close')"
      >
        ENTENDIDO
      </BaseButton> -->
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.Requirements{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .container {
    padding: 2rem 4rem;
    background-color: rgb(33, 33, 49);
    border-radius: 1rem;
    width: 450px;
    text-align: center;
    color: white;
    li{
      margin-top: 10px;
    }
  }
  .BaseButton {
      margin-top: 20px;
      text-align: center;
  }
}

</style>
